<div class="page-transition">
  <!-- Header -->
  <section class="py-10 md:py-14 text-center bg-white">
    <h1 class="text-2xl md:text-3xl font-semibold text-gray-900 mb-1">FAQ</h1>
    <p class="text-sm text-gray-500 mb-3">Looking for a quick answer? You've come to the right place</p>
    <div class="flex items-center justify-center gap-2">
      <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
      <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
    </div>
  </section>

  <!-- FAQ Content -->
  <section class="pb-12 md:pb-16 bg-white">
    <div class="max-w-[1200px] mx-auto px-4 md:px-6">
      <div class="flex flex-col lg:flex-row gap-8 lg:gap-10">

        <!-- LEFT COLUMN -->
        <div class="lg:w-1/2">

          <!-- About Product -->
          <div class="mb-8">
            <h2 class="text-lg font-bold text-gray-900 text-center mb-1">About Product</h2>
            <div class="flex items-center justify-center gap-2 mb-5">
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
            </div>

            <div class="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200">
              <div *ngFor="let faq of aboutProduct; let i = index">
                <button (click)="toggle('product-' + i)" class="w-full flex items-center justify-between px-4 py-3.5 text-left hover:bg-gray-50 transition-colors">
                  <span class="text-sm font-medium text-gray-800 pr-4">{{ faq.q }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 shrink-0 transition-transform duration-300" [class.rotate-180]="openIndex === 'product-' + i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button>
                <div *ngIf="openIndex === 'product-' + i" class="px-4 pb-4 text-sm text-gray-600 leading-relaxed">{{ faq.a }}</div>
              </div>
            </div>
          </div>

          <!-- Email Verification Policy -->
          <div>
            <h2 class="text-lg font-bold text-gray-900 text-center mb-1">Email Verification Policy</h2>
            <div class="flex items-center justify-center gap-2 mb-5">
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
            </div>

            <div class="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200">
              <div *ngFor="let faq of emailVerification; let i = index">
                <button (click)="toggle('email-' + i)" class="w-full flex items-center justify-between px-4 py-3.5 text-left hover:bg-gray-50 transition-colors">
                  <span class="text-sm font-medium text-gray-800 pr-4">{{ faq.q }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 shrink-0 transition-transform duration-300" [class.rotate-180]="openIndex === 'email-' + i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button>
                <div *ngIf="openIndex === 'email-' + i" class="px-4 pb-4 text-sm text-gray-600 leading-relaxed">{{ faq.a }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN -->
        <div class="lg:w-1/2">

          <!-- About Ordering -->
          <div class="mb-8">
            <h2 class="text-lg font-bold text-gray-900 text-center mb-1">About Ordering</h2>
            <div class="flex items-center justify-center gap-2 mb-5">
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
            </div>

            <div class="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200">
              <div *ngFor="let faq of aboutOrdering; let i = index">
                <button (click)="toggle('order-' + i)" class="w-full flex items-center justify-between px-4 py-3.5 text-left hover:bg-gray-50 transition-colors">
                  <span class="text-sm font-medium text-gray-800 pr-4">{{ faq.q }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 shrink-0 transition-transform duration-300" [class.rotate-180]="openIndex === 'order-' + i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button>
                <div *ngIf="openIndex === 'order-' + i" class="px-4 pb-4 text-sm text-gray-600 leading-relaxed">{{ faq.a }}</div>
              </div>
            </div>
          </div>

          <!-- About Gifting -->
          <div>
            <h2 class="text-lg font-bold text-gray-900 text-center mb-1">About Gifting</h2>
            <div class="flex items-center justify-center gap-2 mb-5">
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
              <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
            </div>

            <div class="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200">
              <div *ngFor="let faq of aboutGifting; let i = index">
                <button (click)="toggle('gift-' + i)" class="w-full flex items-center justify-between px-4 py-3.5 text-left hover:bg-gray-50 transition-colors">
                  <span class="text-sm font-medium text-gray-800 pr-4">{{ faq.q }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 shrink-0 transition-transform duration-300" [class.rotate-180]="openIndex === 'gift-' + i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button>
                <div *ngIf="openIndex === 'gift-' + i" class="px-4 pb-4 text-sm text-gray-600 leading-relaxed">{{ faq.a }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</div>
